import { WitaConnector } from '@/services/repository/connector'
import { FormDataHandler } from '@/utils/helpers/FormDataHandler'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  CreateVistaParams,
  CreateVistaResponse,
  DeleteVistaParams,
  DeleteVistaResponse,
  EditVistaParams,
  EditVistaResponse,
  FindVistaByIdParams,
  FindVistaByIdResponse,
  FindVistasByEquipmentIdParams,
  FindVistasByEquipmentIdResponse,
} from '../domain/vista'

const ROOT_URL = '/entity/vistas'

export const VistaService = {
  findByEquipmentId: async (params: FindVistasByEquipmentIdParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<FindVistasByEquipmentIdResponse>(url)
  },

  findById: async ({ vistaId }: FindVistaByIdParams) => {
    const url = ROOT_URL + `/${vistaId}`
    return await WitaConnector.get<FindVistaByIdResponse>(url)
  },

  create: async (params: CreateVistaParams) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL
    return await WitaConnector.post<CreateVistaResponse>(url, formData)
  },

  edit: async ({ id, ...params }: EditVistaParams) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<EditVistaResponse>(url, formData)
  },

  delete: async ({ id }: DeleteVistaParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<DeleteVistaResponse>(url)
  },
}
